import { Component } from '@angular/core';
import { Navigation } from '@app/navigation/enums/navigation.enum';
import { BaseDashboardCardComponent, Svg } from '@smooved/ui';

@Component({
    selector: 'app-post',
    template: `
        <app-minor-service [title]="'DASHBOARD.POST.TITLE' | translate" [routerLink]="postUrl" [icon]="svg.Mail"></app-minor-service>
    `,
})
export class PostComponent extends BaseDashboardCardComponent {
    public svg = Svg;
    public postUrl = `/${Navigation.Post}`;
}
